import "@atlas/ui/tokens.css";
import "./global.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import { ThemeProvider } from "@atlas/ui/web";
import { router } from "./router";
import { ImpersonateBar, ImpersonateOffset } from "./components/ImpersonateBar";
import { accountKey } from "./lib/query-account";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      // Escopa o cache POR conta logada: o hash de cada query leva um prefixo da
      // conta atual, entao contas diferentes nunca compartilham cache (sem
      // vazamento entre prefeituras/bancos) e voltar pra uma conta ja visitada
      // reaproveita o cache dela (sem "Carregando" em todo menu). Ver
      // lib/query-account.ts e login.tsx.
      queryKeyHashFn: (queryKey) => `${accountKey()}|${JSON.stringify(queryKey)}`,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider defaultMode="dark">
      <QueryClientProvider client={queryClient}>
        <ImpersonateBar />
        <ImpersonateOffset>
          <RouterProvider router={router} />
        </ImpersonateOffset>
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>,
);
